module.exports = __webpack_public_path__ + "static/img/logo_bg.3448dbba.png";